export const clientEnv = Object.freeze({
  mode: import.meta.env.MODE,
  isProduction: import.meta.env.PROD,
  publicUrl: import.meta.env.BASE_URL || "/",
  clearpathPhone: import.meta.env.REACT_APP_CLEARPATH_PHONE || "",
  devBaseDomain: import.meta.env.REACT_APP_DEV_BASE_DOMAIN || "",
  devHttpsPort: import.meta.env.REACT_APP_DEV_HTTPS_PORT || "",
  i18nUiEnabled: import.meta.env.REACT_APP_I18N_UI_ENABLED === "true",
  stripeApiKey: import.meta.env.REACT_APP_STRIPE_API_KEY || "",
});

export type ClientEnv = typeof clientEnv;
